import { DB_BACKUP_REQUEST, DB_BACKUP_HISTORY_REQUEST, DB_BACKUP_REQUEST_SUCCESS, DB_BACKUP_REQUEST_FAILURE } from "../types";

const initialState = {
  backupHistory: [],
  loading: false,
  error: null,
};

const dbBackupReducer = (state = initialState, action) => {
  switch (action.type) {
    case DB_BACKUP_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case DB_BACKUP_HISTORY_REQUEST: {
      return {
        ...state,
        backupHistory: [...action.payload],
        loading: false,
        error: null
      }
    }
    case DB_BACKUP_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DB_BACKUP_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default dbBackupReducer;